export default __webpack_public_path__ + "static/media/11.b47d6631.jpg";